var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellbottom01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.89,101.91a4.85,4.85,0,0,0-5,3.9s-4.57,25.35-6.64,46.71c-4.89,50.31-1.3,86.89,1.67,122,1.51,17.77-.23,40.53,1.52,66.4s-13.57,84.3-13.57,84.3a4.8,4.8,0,0,0,4.46,4.46s29.3.19,34.94-.24c5.47-.41,28.1,0,28.1,0a3.84,3.84,0,0,0,3.72-4,3.42,3.42,0,0,0,0-.46s-13.62-58.41-11.72-93.72c2.73-50.44,14-125,14-125a53.15,53.15,0,0,0,.83-8.44l.32-87.9a4.66,4.66,0,0,0-4.24-4.58Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.89,101.91a4.85,4.85,0,0,0-5,3.9s-4.57,25.35-6.64,46.71c-4.89,50.31-1.3,86.89,1.67,122,1.51,17.77-1.09,39.7-1.42,66.44s-10.63,84.26-10.63,84.26a4.8,4.8,0,0,0,4.46,4.46s29.3.19,34.94-.24c5.47-.41,28.1,0,28.1,0a3.84,3.84,0,0,0,3.72-4,3.42,3.42,0,0,0,0-.46s-13.62-58.41-11.72-93.72c2.73-50.44,14-125,14-125a53.15,53.15,0,0,0,.83-8.44l.32-87.9a4.66,4.66,0,0,0-4.24-4.58Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.84
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.11,101.91a4.85,4.85,0,0,1,5,3.9s4.57,25.35,6.64,46.71c4.89,50.31,1.3,86.89-1.67,122-1.51,17.77.23,40.53-1.52,66.4S289.82,425,289.82,425a4.49,4.49,0,0,1-4.26,4.43s-33.19.43-38.83,0c-5.47-.41-24.29-2.48-24.29-2.48a4.67,4.67,0,0,1-3.73-5s13.36-55.23,11.46-90.51c-2.73-50.45-17.51-125.13-17.51-125.13a53.15,53.15,0,0,1-.83-8.44L211.51,110a4.67,4.67,0,0,1,4.24-4.57Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.11,101.91a4.85,4.85,0,0,1,5,3.9s4.57,25.35,6.64,46.71a643.89,643.89,0,0,1,.69,122.92c-1.5,17.78-.36,33.78,2.45,59.56s10.93,90.05,10.93,90.05a4.49,4.49,0,0,1-4.26,4.43s-33.19.43-38.83,0c-5.47-.41-24.29-2.48-24.29-2.48a4.67,4.67,0,0,1-3.73-5s11.23-90.05,11.21-90.48c-2.73-50.45-17.26-125.16-17.26-125.16a53.15,53.15,0,0,1-.83-8.44L211.51,110a4.67,4.67,0,0,1,4.24-4.57Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.84
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.81,103.32V154a12.11,12.11,0,0,1-11.93,11.15,12.77,12.77,0,0,1-1.38-.08V103.33h13.31Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.42
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.46,105.28h9.39V154a10.08,10.08,0,0,1-9.39,9.16Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.36,
    strokeDasharray: 1.42
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5,94.23c14.53,1.73,40.06-.32,40.06-.32A1.34,1.34,0,0,1,225,95.15v.07l.2,10.71a1.47,1.47,0,0,1-1.39,1.49s-10.87.6-15,.67c-10.93.19-24.24.36-40.52-2.47-6.13-1.06-13.24-2.85-13.24-2.85a1.42,1.42,0,0,1-1-1.72l2.59-9.59a1.61,1.61,0,0,1,1.78-1.15Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5,94.23c14.53,1.73,40.06-.32,40.06-.32A1.34,1.34,0,0,1,225,95.15v.07l.2,10.71a1.47,1.47,0,0,1-1.39,1.49s-10.87.6-15,.67c-10.93.19-24.24.36-40.52-2.47-6.13-1.06-13.24-2.85-13.24-2.85a1.42,1.42,0,0,1-1-1.72l2.59-9.59a1.61,1.61,0,0,1,1.78-1.15Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.42
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.51,94.23c-14.53,1.73-40.06-.32-40.06-.32a1.45,1.45,0,0,0-1.54,1.31L198.69,106a1.61,1.61,0,0,0,1.49,1.49s10.87.6,15,.67c10.92.18,24.23.35,40.51-2.48,6.14-1.06,13.24-2.85,13.24-2.85a1.41,1.41,0,0,0,1-1.72l-2.59-9.59a1.61,1.61,0,0,0-1.77-1.15Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240.51,94.23c-14.53,1.73-40.06-.32-40.06-.32a1.45,1.45,0,0,0-1.54,1.31L198.69,106a1.61,1.61,0,0,0,1.49,1.49s10.87.6,15,.67c10.92.18,24.23.35,40.51-2.48,6.14-1.06,13.24-2.85,13.24-2.85a1.41,1.41,0,0,0,1-1.72l-2.59-9.59a1.61,1.61,0,0,0-1.77-1.15Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.42
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 175.42,
    y1: 178.78,
    x2: 176.27,
    y2: 429.48,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.71
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 252.84,
    y1: 179.01,
    x2: 253.7,
    y2: 429.71,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.71
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.4,192.4a17.67,17.67,0,0,1,7.42-5.49,22.23,22.23,0,0,0,2.71-1.26c1.73-.9,2.73-2.63,3.64-4.45s1.89-3.63,2.92-5.4c-5,15.3-6.76,8.34-16.69,16.6Z",
    fill: "#010101",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.44,190.4c-3.3,5.29-6.88,10.4-9.72,16-1.47,2.76-2.94,5.51-4.48,8.23s-3,5.54-2.89,8.7c-.5-3.16.85-6.28,2.21-9.06s2.83-5.57,4.28-8.34a92.48,92.48,0,0,1,10.6-15.49Z",
    fill: "#010101",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.92,183.91c5.78,3.35,9.83,9.64,9.6,16.42A57,57,0,0,0,225,214.7c.41,1.58.9,3.15,1.33,4.73-.65-1.51-1.22-3-1.8-4.58a45.74,45.74,0,0,1-3-14.48c.23-6.64-3.4-12.52-8.6-16.46Z",
    fill: "#010101",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M213.52,172a31.21,31.21,0,0,1,12.17,13.73c2.17,4.16,2.64,8.86,4.18,13.2a9.05,9.05,0,0,0,2.53,3.72,8.67,8.67,0,0,1-3-3.52c-1.85-4.23-2.5-8.88-4.63-13A38,38,0,0,0,213.52,172Z",
    fill: "#010101",
    stroke: "#000",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellbottom01);
export default __webpack_public_path__ + "static/media/BELLBOTTOM-01.03c4a8ca1aaf541e10b88ade8e6b38a6.svg";
export { ForwardRef as ReactComponent };